﻿<template>
  <IonFab :vertical="vertical" :horizontal="horizontal" class="confirm-fab">
    <IonFabButton size="small" @click="toggle" class="toggle-fab-button">
      <IconRenderer :name="props.iconName" size="small" />
    </IonFabButton>
    <IonFabList :side="listSide">
      <IonFabButton @click="handleConfirm" class="succes-fab-button">
        <IconRenderer name="checkmark-circle" />
      </IonFabButton>
    </IonFabList>
  </IonFab>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IonFab, IonFabButton, IonFabList } from '@ionic/vue';
import IconRenderer from '../icon/IconRenderer.vue';

interface Props {
  iconName?: string;
  vertical?: 'top' | 'bottom' | 'center';
  horizontal?: 'start' | 'end' | 'center';
  spreadDirection?: 'top' | 'bottom' | 'left' | 'right';
}

const props = withDefaults(defineProps<Props>(), {
  iconName: 'create-outline',
  vertical: 'bottom',
  horizontal: 'end',
  spreadDirection: 'top',
});

const emit = defineEmits<{
  toggle: [];
  cancel: [];
  confirm: [];
}>();

const listSide = computed(() => {
  switch (props.spreadDirection) {
    case 'top':
      return 'top';
    case 'bottom':
      return 'bottom';
    case 'left':
      return 'start';
    case 'right':
      return 'end';
    default:
      return 'top';
  }
});

const toggle = () => {
  emit('toggle');
};

const handleCancel = () => {
  emit('cancel');
};

const handleConfirm = () => {
  emit('confirm');
};
</script>

<style scoped>
/* Add any custom styling if needed */
ion-fab-button {
  --box-shadow: none;
}

.confirm-fab {
  position: relative;
}

ion-fab-button:hover {
  --box-shadow: var(--ion-box-shadow);
  transition: all 0.2s ease;
}

ion-fab-button.toggle-fab-button,
ion-fab-button.succes-fab-button {
  --background: var(--ion-background-color);
  --color: var(--ion-text-color);
  border: 1px solid var(--ion-background-color-tertiary);
  border-radius: 50%;
  transition: all 0.2s ease;
}
</style>
